import {
   Switch as MantineSwitch,
   SwitchProps as MantineSwitchProps,
} from '@mantine/core'

export const Switch = ({ ...props }: MantineSwitchProps) => {
   return <MantineSwitch {...props} color="rgba(166, 132, 255, 1)" />
}
